import { render, staticRenderFns } from "./records-detail.vue?vue&type=template&id=9afb9dc2&scoped=true"
import script from "./records-detail.vue?vue&type=script&lang=js"
export * from "./records-detail.vue?vue&type=script&lang=js"
import style0 from "./records-detail.vue?vue&type=style&index=0&id=9afb9dc2&prod&lang=less&scoped=true"
import style1 from "./records-detail.vue?vue&type=style&index=1&id=9afb9dc2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afb9dc2",
  null
  
)

export default component.exports